export const privacyPolicyBodyZh = `最近更新：2026年10月3日

本说明介绍使用 pro20.net 在线门户进行预订、下单、咨询以及使用其他服务的用户，其个人数据的处理方式。

## 1. 数据控制者

个人数据的控制者为：

Mada Srl

商号：Mada Srl

地址：Via 4 novembre 12 - Cisternino (BR) 72014

增值税号 / 税号：02750160745

电子邮件：{{email}}

认证电子邮箱（PEC）：-

如需就个人数据保护提出任何请求，可使用上述联系方式联系控制者。

如已任命数据保护官（DPO），可通过以下地址联系：

{{email}}

## 2. 处理的数据类型

使用门户时，根据所使用的服务，可能收集并处理：

- 姓名；
- 电子邮件地址；
- 电话号码及区号；
- 与预订有关的信息；
- 预订人数；
- 预订日期和时间；
- 用户自愿填写的信息和请求；
- 预订和到店记录；
- 与所下订单有关的信息；
- 购买的产品和服务；
- 与订单配送或自取有关的信息；
- 与交易和支付状态有关的信息；
- 促销码、优惠券、积分或会员计划；
- 用户表达的偏好和同意；
- 门户运行和安全所需的技术数据。

请不要在备注或自由填写的请求中提供不必要的信息，尤其是 GDPR 第 9 条所指的特殊类别个人数据，除非为处理该请求确有必要。

## 3. 处理目的和法律依据

### 3.1 预订

处理个人数据是为了：

- 接收并管理预订请求；
- 确认、修改或取消预订；
- 就预订联系顾客；
- 管理到店和在场情况；
- 管理与预订相关的其他请求。

法律依据是履行合同，或应数据主体要求采取合同订立前的措施（GDPR 第 6 条第 1 款 b 项）。

## 4. 订单、外带和配送

如果门户支持下单，个人数据可用于：

- 接收并管理订单；
- 准备所订产品；
- 管理到店自取；
- 安排配送；
- 通知订单状态更新；
- 处理修改、取消或退款；
- 提供客户服务。

法律依据是履行合同，或应数据主体要求采取合同订立前的措施。

## 5. 付款

在提供该功能时，门户可通过专业支付服务商支付订单、订金、预付款、服务费或其他款项。

交易所需数据可直接提供给支付服务商。

餐厅和门户可能收到交易结果信息，例如：

- 付款成功；
- 付款被拒；
- 银行卡授权；
- 已支付订金；
- 退款；
- 交易标识。

当付款由支付服务商直接处理时，餐厅不会存储完整的支付卡数据。

法律依据是履行合同，以及在适用时履行法律义务。

## 6. 与服务有关的通信

用户提供的联系方式可用于发送与所请求服务密切相关的通信，例如：

- 预订确认；
- 请求确认；
- 修改或取消预订；
- 预订提醒；
- 订单确认；
- 订单状态更新；
- 与付款有关的通信；
- 正确履行服务所需的信息。

根据用户提供的联系方式和餐厅开通的服务，这些通信可通过电子邮件、短信、WhatsApp 或其他消息系统发送。

当这些通信对于管理所请求的服务确有必要时，它们不属于促销通信。

## 7. 营销和促销通信

仅在用户同意的情况下，联系数据才可用于发送有关以下内容的商业和促销通信：

- 优惠和促销；
- 活动；
- 新菜单或产品；
- 餐厅活动；
- 优惠券和折扣码；
- 会员计划；
- 个性化商业通信。

通信可通过用户已同意的渠道发送，例如电子邮件、短信、WhatsApp 或适用法律允许的其他方式。

用于营销目的的同意是可选的。

拒绝同意并不妨碍进行预订、下单或使用门户的其他主要服务。

同意可随时撤回，且不影响撤回前已进行的处理的合法性。

## 8. 画像分析和个性化

仅在提供该功能、且法律要求同意时事先取得同意的情况下，控制者可使用用户与餐厅互动的信息，分析兴趣、习惯和偏好。

例如，可考虑以下信息：

- 预订频率；
- 订单记录；
- 购买的产品；
- 促销和优惠券的使用情况；
- 参与会员计划的情况；
- 用户表达的偏好；
- 与促销通信的互动。

这些信息可用于建立客户分组，使优惠、促销和通信更加相关。

在需要同意时，对画像分析的同意是可选的，并可随时撤回。

拒绝同意并不妨碍使用常规的预订和点餐服务。

## 9. 会员计划、促销和优惠券

如果餐厅提供会员计划、促销、积分或优惠券，用户数据可用于：

- 发放积分或权益；
- 核验获得促销的条件；
- 生成优惠券；
- 核验优惠券的使用；
- 管理奖励和权益；
- 防止促销被欺诈性使用。

计划或促销的具体条件可由单独的规则规定。

## 10. 自动化

餐厅可使用自动系统管理与客户关系有关的某些活动。

例如，系统可以自动：

- 在预订前发送提醒；
- 在到店后发送通信；
- 更新预订或订单状态；
- 发放积分或优惠券；
- 在满足特定条件时发送通信。

当这些自动化具有促销目的或涉及画像分析时，适用相应的法律依据，并在必要时事先征得用户同意。

## 11. 数据的提供

提供标为必填的数据，是提供所请求服务所必需的。

例如，未提供预订所需数据时，可能无法完成预订。

为营销和画像分析提供数据和同意是可选的，不影响使用主要服务。

## 12. 数据接收方

个人数据可由控制者授权的人员，以及为经营活动和平台运行提供必要服务的供应商处理。

例如，这些主体可以包括：

- 软件平台供应商；
- 托管和云服务供应商；
- 电子邮件服务供应商；
- 短信服务供应商；
- 消息服务供应商；
- 支付服务供应商；
- 配送服务供应商；
- 技术、行政或税务顾问；
- 代表控制者处理数据的其他主体。

在法律要求时，这些主体作为 GDPR 第 28 条所指的处理者。

在法律义务要求时，数据也可向主管机关披露。

## 13. 向欧洲经济区以外传输数据

控制者使用的某些技术供应商可能在欧洲经济区以外处理个人数据。

在这些情况下，处理和传输将遵守 GDPR，并采用适用的工具和保障措施，例如充分性决定，或在必要时采用欧盟委员会批准的标准合同条款。

## 14. 保存期限

个人数据的保存时间以实现收集目的所需为限，此后按照适用法律要求的期限保存。

具体而言：

- 与预订和订单有关的数据，在管理客户关系以及履行行政、会计或法律义务所需的期限内保存；
- 与交易有关的数据，按照适用的税务和会计义务保存；
- 用于营销的数据，保存至撤回同意，或保存控制者根据必要性和相称性原则确定的其他期限；
- 用于画像分析的数据，在控制者为实现相关目的所确定的期限内保存，之后删除或匿名化。

控制者采用的具体保存期限，可使用本说明中的联系方式查询。

## 15. 数据安全

控制者及相关供应商采取与风险相适应的技术和组织措施，以保护个人数据免遭丢失、毁损、未经授权的访问、披露、篡改或非法处理。

## 16. 数据主体的权利

在 GDPR 规定的情况下，数据主体可以行使其权利，尤其可以要求：

- 查阅其个人数据；
- 更正不准确的数据；
- 删除数据；
- 限制处理；
- 数据可携带；
- 反对处理；
- 撤回先前给予的同意。

撤回同意不影响撤回前已进行的处理的合法性。

请求可发送至：

{{email}}

数据主体还有权按照现行法律规定，向意大利个人数据保护机关（Garante per la protezione dei dati personali）提出投诉。

## 17. Cookie 及类似技术

门户可能使用其运行所必需的 Cookie 和其他技术。

如使用分析类 Cookie、画像分析 Cookie 或第三方 Cookie，由门户上的专门 Cookie 政策规定，并在必要时通过同意管理系统处理。

## 18. 对本说明的修改

控制者可不时更新本说明，以反映法律、技术或所提供服务的变化。

更新版本将通过门户提供。

最近更新：2026年10月03日`;
